import React from "react";
import { Check, Loader2 } from "lucide-react";

export default function Stepper({ steps = [], current = 0 }) {
  return (
    <div className="flex items-center justify-between mb-6" data-testid="widget-stepper">
      {steps.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <React.Fragment key={s}>
            <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all
                  ${done ? "bg-accent text-white" : active ? "bg-primary text-white ring-4 ring-primary/10" : "bg-slate-100 text-slate-400"}`}
                data-testid={`step-${i}`}
              >
                {done ? <Check className="w-4 h-4" /> : i + 1}
              </div>
              <span className={`text-[10px] uppercase tracking-wider font-semibold ${active ? "text-primary" : "text-slate-400"}`}>
                {s}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className={`h-px flex-1 mx-2 ${i < current ? "bg-accent" : "bg-slate-200"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export function OrderStageList({ stages = [] }) {
  return (
    <div className="space-y-3" data-testid="order-stage-list">
      {stages.map((s) => {
        const isComplete = s.status === "completed";
        const isActive = s.status === "active";
        return (
          <div key={s.key} className="flex items-start gap-3" data-testid={`stage-${s.key}`}>
            <div className={`mt-0.5 w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-all
              ${isComplete ? "bg-accent text-white" : isActive ? "bg-primary text-white" : "bg-slate-100 text-slate-400"}`}>
              {isComplete ? <Check className="w-4 h-4" /> : isActive ? <Loader2 className="w-4 h-4 animate-spin" /> : <span className="w-2 h-2 bg-slate-400 rounded-full" />}
            </div>
            <div className="flex-1">
              <div className={`font-display font-semibold ${isComplete || isActive ? "text-primary" : "text-slate-400"}`}>
                {s.label}
              </div>
              {s.ts && (
                <div className="text-xs text-slate-500 font-mono mt-0.5">
                  {new Date(s.ts).toLocaleTimeString("en-IE", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
